import { useContext } from 'react';
import { ToastContext } from '../services/ToastContext';

export const useToast = () => useContext(ToastContext);